<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                :aria-label="'Alterar tema. Tema atual: ' + currentThemeLabel"
                aria-haspopup="menu"
            >
                <v-icon aria-hidden="true">{{ currentThemeIcon }}</v-icon>
            </v-btn>
        </template>
        
        <v-list 
            role="menu" 
            aria-label="Selecione um tema"
            dense
        >
            <!-- NOSONAR: aria-checked is dynamically bound via Vue -->
            <v-list-item
                v-for="theme in themes"
                :key="theme.value"
                @click="selectTheme(theme.value)"
                role="menuitemradio"
                :aria-checked="currentTheme === theme.value ? 'true' : 'false'"
            >
                <v-list-item-icon>
                    <v-icon 
                        :color="currentTheme === theme.value ? 'primary' : ''"
                        aria-hidden="true"
                    >
                        {{ theme.icon }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ theme.label }}</v-list-item-title>
                    <v-list-item-subtitle v-if="theme.description">
                        {{ theme.description }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="currentTheme === theme.value">
                    <v-icon small color="primary" aria-hidden="true">mdi-check</v-icon>
                    <span class="sr-only">Selecionado</span>
                </v-list-item-action>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { setTheme } from '@/plugins/vuetify'

export default {
    name: 'EmcAccessibilityThemeToggle',
    
    data() {
        return {
            currentTheme: 'light',
            themes: [
                {
                    value: 'light',
                    label: 'Tema Claro',
                    description: 'Fundo branco com texto escuro',
                    icon: 'mdi-white-balance-sunny'
                },
                {
                    value: 'dark',
                    label: 'Tema Escuro',
                    description: 'Fundo escuro com texto claro',
                    icon: 'mdi-moon-waning-crescent'
                },
                {
                    value: 'highContrast',
                    label: 'Alto Contraste',
                    description: 'Maior contraste para baixa visão',
                    icon: 'mdi-contrast-circle'
                }
            ]
        }
    },
    
    computed: {
        currentThemeLabel() {
            const theme = this.themes.find(t => t.value === this.currentTheme)
            return theme ? theme.label : 'Claro'
        },
        
        currentThemeIcon() {
            const theme = this.themes.find(t => t.value === this.currentTheme)
            return theme ? theme.icon : 'mdi-white-balance-sunny'
        }
    },
    
    mounted() {
        const savedTheme = localStorage.getItem('sysclass-theme')
        if (savedTheme) {
            this.currentTheme = savedTheme
        }
    },
    
    methods: {
        selectTheme(themeName) {
            this.currentTheme = themeName
            setTheme(themeName)
            
            // Anuncia mudança para leitores de tela
            this.$nextTick(() => {
                const message = `Tema alterado para ${this.currentThemeLabel}`
                this.announceChange(message)
            })
        },
        
        announceChange(message) {
            // Cria ou reutiliza região de anúncio
            let announcer = document.getElementById('theme-announcer')
            if (!announcer) {
                announcer = document.createElement('div')
                announcer.id = 'theme-announcer'
                announcer.className = 'sr-only'
                announcer.setAttribute('aria-live', 'polite')
                announcer.setAttribute('aria-atomic', 'true')
                document.body.appendChild(announcer)
            }
            
            announcer.textContent = ''
            setTimeout(() => {
                announcer.textContent = message
            }, 100)
        }
    }
}
</script>
